import React, { useState, useEffect } from 'react';

interface FloatingTooltipProps {
  text: string;
  isVisible: boolean;
  alignmentScore?: string;
}

const FloatingTooltip: React.FC<FloatingTooltipProps> = ({ text, isVisible, alignmentScore }) => {
  const [position, setPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      setPosition({
        x: e.clientX + 15,
        y: e.clientY - 10,
      });
    };

    if (isVisible) {
      window.addEventListener('mousemove', handleMouseMove);
    }

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, [isVisible]);

  if (!isVisible) return null;

  const getScoreStyles = (score?: string) => {
    switch (score?.toLowerCase()) {
      case 'high':
        return 'bg-[#C8E6C9] text-[#388E3C]';
      case 'medium':
        return 'bg-[#FFF9C4] text-[#F57F17]';
      case 'low':
        return 'bg-[#F8BBD0] text-[#C2185B]';
      default:
        return 'bg-[#F5F5F5] text-[#757575]';
    }
  };

  return (
    <div
      className="fixed z-50 pointer-events-none"
      style={{
        left: `${position.x}px`,
        top: `${position.y}px`,
        transform: 'translate(0, -100%)',
      }}
    >
      <div className="bg-[#FFFFFF] p-3 rounded-md text-sm font-light whitespace-normal max-w-[300px] shadow-[0_2px_8px_rgba(0,0,0,0.08)] border border-[#EEEEEE] animate-fadeIn">
        {alignmentScore && (
          <div className="mb-2">
            <span className={`px-2 py-1 rounded-lg text-xs font-normal ${getScoreStyles(alignmentScore)}`}>
              {alignmentScore.charAt(0).toUpperCase() + alignmentScore.slice(1)}
            </span>
          </div>
        )}
        <div className="text-[#222222]">
          {text}
        </div>
      </div>
    </div>
  );
};

export default FloatingTooltip; 